import { useEffect } from "react";
import { useAppSelector } from "@/shared/hooks/store";
import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { selectOnboardingUser, selectSelectedMedication } from "@/store/slices/onboarding/selectors";
import AddMedicationLayout from "./components/medications/medbox-layout";

interface AddMedicationProviderType {
    OTCAsRx: boolean | null;
    setOTCAsRx: (value: boolean | null) => void;
    packaging: string | null;
    setPackaging: (value: string | null) => void;
}

export const AddMedicationProvider = createContext<AddMedicationProviderType | null>(null);

const AddFlowWrapper = () => {
    const user = useAppSelector(selectOnboardingUser)!;
    const selectedMedication = useAppSelector(selectSelectedMedication);
    const transferPrescriptionList = user?.transferPrescriptions || [];

    const [OTCAsRx, setOTCAsRx] = useState<boolean | null>(null);
const [packaging, setPackaging] = useState<string | null>(null);

    useEffect(() => {
        if (!selectedMedication) {
            setOTCAsRx(null);
            setPackaging(null);
            return;
        }
    }, [selectedMedication])

    return (
        <AddMedicationProvider.Provider value={{ OTCAsRx, setOTCAsRx, packaging, setPackaging }}>
            <AddMedicationLayout
                otcAsRx={OTCAsRx}
                selectedMedication={selectedMedication}
                prescriptionsLength={transferPrescriptionList.length}
                packaging={packaging}
                mainContent={
                    <>
                        <Outlet />
                    </>
                }
            />
        </AddMedicationProvider.Provider >
    )
}

export default AddFlowWrapper;